import React from 'react'
import { useNavigate } from 'react-router-dom'
import { getThemeColors } from '../theme'

export default function Footer({ theme }) {
  const C = getThemeColors(theme)
  const navigate = useNavigate()

  return (
    <footer
      style={{
        borderTop: `0.5px solid ${C.border}`,
        paddingTop: '18px',
        marginTop: '32px',
        paddingBottom: '18px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '16px',
        flexWrap: 'wrap',
      }}>
      <div style={{ fontSize: '13px', fontWeight: '500', color: C.text }}>
        Job<span style={{ color: C.blue }}>Pipeline</span>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
        <button
          onClick={() => navigate('/about')}
          style={{
            fontSize: '12px',
            color: C.blue,
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
          }}>
          About
        </button>

        <button
          onClick={() => navigate('/faqs')}
          style={{
            fontSize: '12px',
            color: C.blue,
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
          }}>
          FAQs
        </button>

        <button
          onClick={() => navigate('/cambios')}
          style={{
            fontSize: '12px',
            color: C.blue,
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
          }}>
          Historial de cambios
        </button>

        <button
          onClick={() => navigate('/privacidad')}
          style={{
            fontSize: '12px',
            color: C.blue,
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
          }}>
          Privacidad
        </button>

        <button
          onClick={() => navigate('/terminos')}
          style={{
            fontSize: '12px',
            color: C.blue,
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
          }}>
          Términos
        </button>

        <button
          onClick={() => navigate('/feedback')}
          style={{
            fontSize: '12px',
            color: C.blue,
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
          }}>
          Feedback y contacto
        </button>

        <div style={{ fontSize: '12px', color: C.subtle }}>
          © 2026 JobPipeline · Hecho para profesionales que no tienen tiempo de buscar empleo
        </div>

        <div style={{ fontSize: '12px', color: C.subtle }}>
          Narevya visual identity © acuneo
        </div>
      </div>
    </footer>
  )
}
